var angular = require("angular");
var PortalAPI = require("../api").Portal;
var Promise = require("bluebird");

module.exports = ResetPassword;

function ResetPassword($scope, $state, $location, $timeout) {
    var token = $location.search().token;
    var email = $location.search().email;
    var init = function() {
        $scope.passwordCtrlFocused = true;
    };
    $scope.buttonMessage = "Reset Password";
    $scope.submit = function() {
        var senderObject = { token: token, password: $scope.vm.password };
        $scope.waitingOnServer = true;
        $scope.buttonMessage = "Resetting Password";
        PortalAPI.confirmForgotPasswordToken(senderObject)
            .then(function () {
                $scope.buttonMessage = "Logging In";
                return PortalAPI.oneHitLogin(email, $scope.vm.password)
                    .then(function(response) {
                        window.location.href = response.redirect;
                    }).error(function() {
                        alert("An unexpected error has occured");
                    });
            }).error(function(error) {
                if (error.body && error.body.message) {
                    $scope.waitingOnServer = false;
                    $scope.buttonMessage = "Reset Password";
                    $scope.vm.serverError = error.body.message;
                }
            });
    };

    $scope.resendEmail = function() {
        PortalAPI.forgotPassword({
            email: email
        }).then(function() {
            delete $scope.vm.serverError;
            $scope.vm.resentLink = true;
        }).error(function() {
            alert("An unexpected error has occured");
        });
    };

    init();
}
